import { endpoints, request } from '!core/api';

export const loginServices = {
  login: (username, hashPassword) =>
    request.postWebService(endpoints.webservices('login'), {
      username,
      key: hashPassword,
    }),
  salt: (user) =>
    request.getWebService(endpoints.webservices(`userInfo?username=${user}`)),
  passwordRecover: ({ userId }) =>
    request.post(endpoints.chnn(`SetPasswordRecovery?userId=${userId}`)),
};
